import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import FieldInput from "./fields/FieldInput";
import { AuditType } from "../../types/auditTypes";

const schema = z.object({
  name: z.string().min(1, "Requis").max(50, "50 caractÃ¨res max"),
  code: z.string().min(1, "Requis").max(20, "20 caractÃ¨res max"),
  description: z.string().max(150, "150 caractÃ¨res max").optional(),
});

export type SchemaFormAuditType = z.infer<typeof schema>;

export const transformAuditTypeToFormValues = (
  auditType?: AuditType,
): SchemaFormAuditType => {
  if (!auditType) return { name: "", code: "", description: "" };
  return {
    name: auditType.name,
    code: auditType.code,
    description: auditType.description ?? "",
  };
};

type Props = {
  onSubmit: SubmitHandler<SchemaFormAuditType>;
  defaultValues?: SchemaFormAuditType;
};

const FormAuditType: React.FC<Props> = ({ onSubmit, defaultValues }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SchemaFormAuditType>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  return (
    <Form onFinish={handleSubmit(onSubmit)} id="form-audit-type">
      <FieldInput<SchemaFormAuditType>
        control={control}
        name="name"
        label="Nom"
        placeholder="Nom..."
        errorMessage={errors?.name?.message}
        isVertical
      />
      <FieldInput<SchemaFormAuditType>
        control={control}
        name="code"
        label="Code"
        placeholder="Code..."
        errorMessage={errors?.code?.message}
        isVertical
      />
      <FieldInput<SchemaFormAuditType>
        control={control}
        name="description"
        label="Description"
        placeholder="Description..."
        errorMessage={errors?.description?.message}
        isVertical
      />
    </Form>
  );
};

export default FormAuditType;
